import React from "react";
import { cva, type VariantProps } from "class-variance-authority";

const buttonVariants = cva(
  "inline-flex items-center justify-center font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-bg-surface)] disabled:opacity-50 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        primary: "bg-orange-500 text-white hover:bg-orange-600 active:bg-orange-700",
        secondary:
          "bg-[var(--color-bg-surface)] text-[var(--color-text-primary)] border border-[var(--color-border-default)] hover:bg-[var(--color-bg-hover)]",
        ghost: "text-[var(--color-text-primary)] hover:bg-[var(--color-bg-hover)]",
      },
      size: {
        sm: "h-8 px-3 text-sm rounded-md",
        default: "h-10 px-6 py-2 text-sm rounded-lg",
        lg: "h-12 px-8 text-base rounded-lg",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  children: React.ReactNode;
}

const Button = React.forwardRef<React.ElementRef<"button">, ButtonProps>(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <button className={buttonVariants({ variant, size, className })} ref={ref} {...props}>
        {children}
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
